/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA ;
 */
export const spellCheckConfigs = {
    wproofreader: {
        /**
         * @param {Object} receivedConfig
         * @param {string} receivedConfig.srcUrl
         * @param {string} receivedConfig.serviceId
         * @param {string} [receivedConfig.lang]
         * @returns {Object}
         */
        getEditorConfig(receivedConfig) {
            // prettier-ignore
            // https://webspellchecker.com/docs/api/wscbundle/Options.html
            return Object.assign({
                // tenant must override:
                srcUrl: 'https://svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js',
                serviceId: '', // license key

                // tenant or LTI claim can override:
                lang: 'auto',
                minWordLength: 3,
                autocorrect: false,
                enableGrammar: false,
                disableStyleGuide: true,
                spellingSuggestions: true,
                grammarSuggestions: false,
                styleGuideSuggestions: false,
                settingsSections: ['languages'],
                detectLocalizationLanguage: true,
                ignoreAllCapsWords: true,
                enableBadgeButton: false,
                requestTokensCount: 3,
                disableDialog: true,
                disableOptionsStorage: ['lang'],
                actionItems: ['ignoreAll', 'settings'],
                cache: true,
                onErrorRequest: function (data) {
                    console.error('[wproofreader]', data); // eslint-disable-line no-console
                }
            }, receivedConfig);
        }
    }
};
